import { Timestamp } from './timestamp';
import { ActionEvents } from './tracking/action-events';

export enum PmfDisappointment {
  VeryDisappointed = 'very_disappointed',
  SlightlyDisappointed = 'slightly_disappointed',
  NotDisappointed = 'not_disappointed',
  NoLongerUse = 'no_longer_use',
}

export enum PmfStepId {
  HowWouldYouFeel = 'how_would_you_feel',
  MainBenefit = 'main_benefit',
  IdealPerson = 'ideal_person',
  Improvement = 'improvement',
  Missing = 'missing',
  ChurnReason = 'churn_reason',
}

export enum PmfQuestionType {
  SingleSelect = 'single_select',
  FreeText = 'free_text',
}

export type PmfSurveyOption = {
  value: PmfDisappointment;
  labelKey: string;
};

export type PmfSurveyFreeTextEvent =
  | ActionEvents.PmfSurveyMainBenefit
  | ActionEvents.PmfSurveyIdealPerson
  | ActionEvents.PmfSurveyImprovement
  | ActionEvents.PmfSurveyMissing
  | ActionEvents.PmfSurveyChurnReason;

export type PmfSurveySingleSelectStep = {
  id: PmfStepId;
  type: PmfQuestionType.SingleSelect;
  titleKey: string;
  event: ActionEvents.PmfSurveyHowWouldYouFeel;
  options: PmfSurveyOption[];
  branch: Record<PmfDisappointment, PmfStepId>;
};

export type PmfSurveyFreeTextStep = {
  id: PmfStepId;
  type: PmfQuestionType.FreeText;
  titleKey: string;
  placeholderKey?: string;
  event: PmfSurveyFreeTextEvent;
  next: PmfStepId | null;
};

export type PmfSurveyStep = PmfSurveySingleSelectStep | PmfSurveyFreeTextStep;

export type PmfSurveyConfig = {
  firstStepId: PmfStepId;
  steps: Record<PmfStepId, PmfSurveyStep>;
};

export type UsageStatisticsEntry = {
  date: Timestamp;
  completionCount: number;
};

export type PmfSurvey = {
  surveyShownCount: number;
  lastTimeShown: Timestamp | null;
  surveyCompleted: boolean;
};
